import * as i18n from 'i18next';
import * as LanguageDetector from 'i18next-browser-languagedetector';
import * as Backend from 'i18next-xhr-backend';
import { first, values } from 'lodash';
import {reactI18nextModule} from 'react-i18next';

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(reactI18nextModule)
	.init({
		debug: true,
		defaultNS: 'translations',
		fallbackLng: 'en',
		interpolation: {
      escapeValue: false, // not needed for react!!
		},
    // have a common namespace used around the full app
    ns: ['translations'],
		react: {
			wait: true
		}
	});

export default i18n;

export function get_ti18n(props: any) {
	const langCode = props.i18n.language.substr(0, 2);
	return (i18nObject: any, key: string|number) => {
		if (i18nObject && i18nObject[key]) {
			if (i18nObject[key][langCode]) {
				return i18nObject[key][langCode]
			}
			else {
				return first(values(i18nObject[key]))
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n.ts